import { message } from 'antd';
import React, { useState } from 'react';

import Icon from '@ant-design/icons';
import FilterIcon from '@icons/emp/filter-icon.svg';
import { usePostShareFunnel } from '@src/emp-3.0/api/queryHooks';
import { useFunnelStore } from '@src/emp-3.0/components/Funnel/store';
import RangePicker from '@src/emp-3.0/components/Sankey/GlobalFilter/RangePicker';
import { Title, Wrapper } from '@src/emp-3.0/components/Sankey/GlobalFilter/styled';
import { ShareButton, SharingModal, updateShareId } from '@src/emp-3.0/components/common/Sharing';
import { trackFunnelShare } from '@src/sensor';

import { FilterList } from '../Sankey/GlobalFilter';
import { DURATION_ALLOWED_IN_DAYS } from '../Sankey/constants';

const FilterWrapper = ({ dimensionOptions, onChange, mask, calenderBoundry }) => {
  const { funnelData, funnelRequestBody, generateFunnelRequestBody } = useFunnelStore(
    (state) => state,
  );
  const { filters, interval } = funnelRequestBody;

  const [visible, setVisible] = useState<boolean>(false);
  const [shareId, setShareId] = useState<number>(-1);

  const { mutate: generateShareFunnel, isLoading: isLoadingGenerateShareFunnelId } =
    usePostShareFunnel();

  const hasFunnelData = funnelData?.funnel_data?.length > 0;

  const generateShareFunnelId = () => {
    trackFunnelShare({ ...generateFunnelRequestBody });
    generateShareFunnel(
      { payload: generateFunnelRequestBody },
      {
        onSuccess: (data) => {
          setShareId(data.id);
          updateShareId(data.id);
        },
        onError: (error: any) => {
          message.error(error?.response?.data?.msg);
        },
      },
    );
  };

  const onClickShare = () => {
    generateShareFunnelId();
    setVisible(true);
  };

  const disableStyle: React.CSSProperties = mask ? { opacity: 0.6, pointerEvents: 'none' } : {};
  return (
    <Wrapper>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Title>Funnel</Title>
        <Icon component={FilterIcon} style={{ fontSize: '16px', margin: '0 12px' }} />
        <FilterList
          interval={interval}
          dimensionOptions={dimensionOptions}
          fixedDimensions={['app_id']}
          filters={filters}
          onChange={(value) => {
            onChange?.({ filters: value });
          }}
          style={disableStyle}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <RangePicker
          interval={interval}
          onChange={(value) => {
            if (value !== interval && value !== '') {
              onChange?.({ interval: value });
            }
          }}
          durationLimit={DURATION_ALLOWED_IN_DAYS}
          calenderBoundry={calenderBoundry}
        />
        <ShareButton disabled={!hasFunnelData || mask} onClick={onClickShare} />
      </div>
      <SharingModal
        id={shareId}
        fetching={isLoadingGenerateShareFunnelId}
        modalProps={{
          title: 'Share Funnel',
          open: visible,
          onCancel: () => setVisible(false),
        }}
      />
    </Wrapper>
  );
};

export default FilterWrapper;
